module.exports = __webpack_public_path__ + "img/supplier_0.747b85d6.webp";